import { cn } from "@/lib/utils";

const STATUS_LABELS: Record<string, string> = {
  received: "Received",
  in_review: "In review",
  awaiting_revision: "Awaiting revision",
  completed: "Completed",
};

function statusPillClass(status: string) {
  switch (status) {
    case "completed":
      return "bg-emerald-100 text-emerald-800";
    case "in_review":
      return "bg-blue-100 text-blue-800";
    case "awaiting_revision":
      return "bg-amber-100 text-amber-800";
    default:
      return "bg-slate-100 text-slate-700";
  }
}

export function SubmissionStatusPill({ status }: { status: string }) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium whitespace-nowrap",
        statusPillClass(status),
      )}
    >
      {STATUS_LABELS[status] ?? status}
    </span>
  );
}
